import { CreateRoleFormValues } from '../schema';

export enum CreateRoleFormFieldNames {
    Name = 'name',
    Privileges = 'privileges',
}

export const defaultValues: CreateRoleFormValues = {
    [CreateRoleFormFieldNames.Name]: '',
    [CreateRoleFormFieldNames.Privileges]: {},
};
